import Vue from 'vue';
import Router from '@app/router';
import Store from '@app/store';
export default {
    /*
    * Updates page title and meta description
    */
    updateMedadata: function (route) {
        document.title = route.meta.title;
        var metaDescEl = document.querySelector('meta[name="description"]');
        if (!metaDescEl) {
            metaDescEl = document.createElement('meta');
            metaDescEl.setAttribute('name', 'description');
            document.head.insertBefore(metaDescEl, document.querySelector('meta[name="author"]'));
        }
        metaDescEl.setAttribute("content", route.meta.description);
        // Update Open Graph Tags
        this.setMetaTag('property="og:url"', "".concat(window.location.protocol, "//").concat(window.location.host).concat(route.path));
        this.setMetaTag('property="og:title"', route.meta.title);
        this.setMetaTag('property="og:description"', route.meta.description);
    },
    /*
    * Function to convert a Nitrous Uri model to a Vue route
    */
    makeRoute: function (uri) {
        var meta = {
            id: uri.id,
            title: uri.page_title,
            layout: uri.layout,
            description: uri.meta_description,
            isHome: uri.id === window.HOMEPAGE_URI.id,
            otherLanguages: uri.otherLanguages || [],
            type: uri.controllerType,
            hasPageData: true,
        };
        var path = '/' + (uri.slug == '/' ? '' : uri.slug);
        var route = {
            name: meta.isHome ? 'home' : "page-".concat(uri.id),
            path: path,
            meta: meta,
            component: function () { return import(
            /* webpackChunkName: "[request]" */
            /* webpackPrefetch: true */
            /* webpackPreload: true */
            "@app/modules/".concat(uri.controllerType, "Controller.vue")); },
            props: {
                getPage: function () { return Store.STATE.pageData[path]; }
            },
            beforeEnter: function (to, from, next) {
                if (uri.uriable && uri.uriable.parent.layout == 'auth' && !Vue.user) {
                    return next({ name: 'home' });
                }
                return next();
            }
        };
        return route;
    },
    /*
    * Function for scrolling to an anchor
    */
    scrollToAnchor: function (anchor) {
        var el = document.querySelector(anchor);
        if (el) {
            Vue.helpers.scrollTo(el);
        }
    },
    /**
     * Sets or updates the content property on a given meta tag
     *
     * @param tag Meta tag selector
     * @param content Meta content to set
     */
    setMetaTag: function (propertySelector, content) {
        var el = document.querySelector("meta[".concat(propertySelector, "]"));
        if (el) {
            el.setAttribute('content', content);
        }
    },
    /**
     * Check if a given path can be matched to a router route
     * Excludes the 404 catch-all route
     *
     * @param path Path to check
     */
    routeExists: function (path) {
        var matched = Router.resolve(path).resolved.matched;
        return matched.length === 1
            && matched[0].name !== '404';
    },
    /**
     * Define final routes that will be added to the router at last
     */
    addFinalRoutes: function () {
        var redirects = window.REDIRECTS;
        if (redirects) {
            Router.addRoutes(redirects.map(function (redirect) {
                return {
                    path: redirect.from,
                    redirect: redirect.to
                };
            }));
        }
        Router.addRoutes([
            {
                name: '404',
                path: '*',
                component: function () { return import(/* webpackChunkName: "PageNotFound" */ '@app/components/errors/404.vue'); }
            }
        ]);
    }
};
